import Vue from 'vue';

import { authHeader } from '../_helpers';

export const userService = {
  login,
  logout,
  register,
  registerConfirm,
  resetPasswordConfirm,
  resetConfirm,
  getAll,
  getById,
  update,
  delete: _delete
};

function login(userName, password, empresa, modulo) {
  return Vue.axios
    .post(`/auth`, { userName, password, empresa, modulo })
    .then(response => {
      if (response.statusText !== 'OK') {
        if (response.status === 401) {
          logout();
          return;
        }
      }

      const user = response.data;
      if (user.token) {
        localStorage.setItem('token', JSON.stringify(user.token));
        localStorage.setItem('tipo', JSON.stringify(user.tipo));

        if (user.empresas) {
          localStorage.setItem('empresas', JSON.stringify(user.empresas));
          localStorage.setItem('empresaAtual', user.empresas[0].sigla);
        }
      }

      return user;
    })
    .catch(error => handleResponse(error.response));
}

function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('empresas');
  localStorage.removeItem('tipo');
  localStorage.removeItem('empresaAtual');
  sessionStorage.clear();
}

function register(user) {
  return Vue.axios.post(`/register`, user);
}

function registerConfirm(payloadReset, userId) {
  payloadReset.login = userId;
  return Vue.axios.post(`/register/confirm`, payloadReset);
}

// REG-809: a confirmacao da RECUPERACAO de senha vai para /reset/confirm/<token>, nunca
// para /register/confirm. Desde o REG-733 o link do e-mail carrega um token opaco de 43
// chars; o /register/confirm ainda o decifrava como AES e respondia 400
// (BadPaddingException). O token viaja no path, e nao no campo `login` do corpo.
function resetPasswordConfirm(payloadReset, token) {
  return Vue.axios.post(`/reset/confirm/${encodeURIComponent(token)}`, payloadReset);
}

function resetConfirm(userId) {
  return Vue.axios.post(`/reset/confirm/${userId}`);
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/users`, requestOptions).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/users/${id}`, requestOptions).then(handleResponse);
}

function update(user) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
  };

  return fetch(`/users/${user.id}`, requestOptions).then(handleResponse);
}

function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`/users/${id}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return new Promise((resolve, reject) => {
    if (response === undefined || response == null) {
      reject('Impossível comunicar com servidor.');
    }

    const data = response.data;
    if (response.statusText !== 'OK') {
      if (response.status === 401) {
        logout();
      }

      let error = '';
      if (data) {
        if (data.message) {
          if (data.message == '' && data.error) error = data.error;
          else error = data.message;
        } else {
          if (data.error) error = data.error;
          else error = data;
        }
      } else {
        error = response.statusText;
      }

      reject(error);
    }

    resolve(data);
  });
}
